import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import Fr_Input from "../../../lib/ui/fr_input";

import Wnd_Error from "../../../lib/ui/wnd_error";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Wnd_Info from "../../../lib/ui/wnd_info";
import Wnd_Confirm from "../../../lib/ui/wnd_confirm";
import * as utils from "../../../assets/utils";
import Fr_Cal from "../../../lib/ui/fr_cal";

class Prj_add extends React.Component {
  constructor(props, context) {
    super(props);

    this.bcs = props.store.bcs;
    this.state = {};
    this.state.mka = [];
    this.state.sval = [];
    this.state.tval = [];
    this.state.paa = [];
    this.state.uaa = [];
    this.state.laa = [];

    this.state.gnr = "001";
    //this.state.lro = props.lro;
    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];

    this.state.msg = {};
    this.state.cols = {};
      this.state.lko = {};
      this.state.lko.lk00 = {};
      this.state.lko.lk01 = {};
      this.state.lko.lk02 = {};
      this.state.tabval = 0;
      this.state.kanm = "";
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      //this.lko_init();
  }

    lko_init() {
        var lko = {};
        lko.lk00 = {};
        lko.lk00.typ = "";
        lko.lk00.lid = "";
        lko.lk00.ftg = "";
        lko.lk00.ref = "";
        lko.lk00.orgnr = "";
        lko.lk02.tele = "";
        //alert(JSON.stringify(rso));
        this.setState({ lko: lko });
        return;
    }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 275;
        return css;
    }
    tab_style(tabid) {
        var css = {};
        css.display = "none";
        if(this.state.tabval === tabid) css.display = "block";
        return css;
    }
    tab_head(tabid) {
        var css = {};
        css.background = "#fff";
        css.color = "#000";
        if(this.state.tabval === tabid) {
            css.background = "#080";
            css.color = "#fff";
        }
        return css;
    }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pbo = this.state.pbo;
      var na = name.split(".");
      pbo[na[0]][na[1]] = value;
      this.setState({pbo: pbo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
      if(this.props.close) {
          this.props.close(this.props.ctx);
      }
      else this.props.ctx.setState({ wnds: {} });
	};

  val_save(id, val) {
    var lko = this.state.lko;
    var na = id.split(".");
      lko[na[0]][na[1]] = val;
    this.setState({ lko: lko });
    return;
  }
    val_anm_save(e) {
        const value = e.target.value;
        var lko = this.state.lko;
        lko.lkdata = value;
        this.setState({lko: lko});
    }
    lk_add() {
        var self = this;
        var prm = {};
        prm.req = "bcs.lreg.lk_add";
        prm.lko = this.state.lko;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret));
                if(ret.ok == "000") {
                    self.setState({ msg: {ok: true, text: "Sparad ..."} });
                    setTimeout(function(){
                        self.setState({msg: {} });
                        if(self.props.wnds.cb) {
                            self.props.wnds.cb(self.props.ctx);
                        }
                        else self.props.ctx.setState({ wnds: {} });
                        return;
                    }, 1000);
                }
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }

  render() {
    //if(!this.props.show) return "";
    var title = this.props.title;
    if(!title) title = "Resurs";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_80 flex-col" style={ this.dlg_style() } >
        <div className="mx_content flex">

        <div className="mx_h01">
            <div>NYTT PROJEKT</div>
            <div className="flex"></div>
            <div onClick={() => this.wnd_close() }>X</div>
        </div>
            <div className="flex-row">
                <div className="tab_header flex" style={ this.tab_head(0) } onClick={ () => this.setState({tabval: 0}) }>INFORMATION</div>
                <div className="tab_header flex" style={ this.tab_head(1) } onClick={ () => this.setState({tabval: 1}) }>ANMÄRKNING</div>
                <div className="tab_header flex" style={ this.tab_head(2) } onClick={ () => this.setState({tabval: 2}) }>PUNKTER</div>
            </div>
            <div className="divider_orange"></div>

            <div style={ this.tab_style(0) }>
            <form className="cdi_f03">
                <div className="flex-row">
                    <Fr_Input label="Text" className="text-left w350" text={this.state.lko.lk00.text} getValue={(e)=> this.val_save("lk00.text", e) } />
                    <Fr_Input label="LID" className="text-left w150" text={this.state.lko.lk00.lid} getValue={(e)=> this.val_save("lk00.lid", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Företag" className="text-left w350" text={this.state.lko.lk00.ftg} getValue={(e)=> this.val_save("lk00.ftg", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Orgnr" className="text-left w250" text={this.state.lko.lk00.orgnr} getValue={(e)=> this.val_save("lk00.orgnr", e) } />
                    <Fr_Input label="Tele" className="text-left w250" text={this.state.lko.lk02.tele} getValue={(e)=> this.val_save("lk02.tele", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Referens" className="text-left w250" text={this.state.lko.lk00.ref} getValue={(e)=> this.val_save("lk00.ref", e) } />
                    <Fr_Cal label="Startdag" className="text-left w200" text={this.state.lko.lk00.reg} getValue={(e)=> this.val_save( "lk00.reg", e ) }/>
                </div>

                <div className="divider_green"></div>
                <div className="flex-row">
                    <Fr_Input label="Postadress" className="text-left w250" text={this.state.lko.lk01.postal} getValue={(e)=> this.val_save("lk01.postal", e) } />
                    <Fr_Input label="Gata" className="text-left w350" text={this.state.lko.lk01.street} getValue={(e)=> this.val_save("lk01.street", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Postnr" className="text-left w150" text={this.state.lko.lk01.zip} getValue={(e)=> this.val_save("lk01.zip", e) } />
                    <Fr_Input label="Stad" className="text-left w350" text={this.state.lko.lk01.city} getValue={(e)=> this.val_save("lk01.city", e) } />
                </div>

            </form>
            </div>

            <div style={ this.tab_style(1) }>
                <form className="cdi_f03">
                    <div className="flex flex-column" style={{padding: "0px 5px"}}>
                        <label>Anmärkning</label>
                        <textarea className="form-control" maxLength="512" rows="10" value={ this.state.lko.lkdata } onChange={(event) => this.val_anm_save(event)} />
                    </div>
                </form>
            </div>

        </div>
        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex-row">
            <button className="btn btn-hw-green w250" onClick={() => this.lk_add() } >
                SPARA
            </button>
            </div>
        </div>
      </div>

            <Wnd_Error msg={this.state.msg} ctx={this} />
            <Wnd_Ok msg={this.state.msg} ctx={this} />
            <Wnd_Info msg={this.state.msg} ctx={this} />
            <Wnd_Confirm msg={this.state.msg} ctx={this} />
      </div>
	;
	return html;
  };
}

export default Prj_add;